import DrawerHeaderProvider from './hooks/useDrawerHeader';

import { DrawerHeaderProps } from './@types/DrawerHeaderProps';
import { useCssHandles } from '../../../utils/functions';

const CSS_HANDLES = ['drawerHeader'] as const;
const DrawerHeader = (props: DrawerHeaderProps) => {
	const { handles }: any = useCssHandles('vtex-store-drawer-0-x-', CSS_HANDLES, props.blockClass);

	return (
		<DrawerHeaderProvider {...props}>
			<div className={`flex ${handles.drawerHeader}`}>{props.children}</div>
		</DrawerHeaderProvider>
	);
};

export default DrawerHeader;
